// test92
(92 && 0);
